import Icon from "../../../../components/icon";

export const Error = ({message}) => {
    return (<span className="error d-flex">
        <Icon name="alert" />
        {message}
    </span>)
}